import React from 'react'

export const MARK_FONT_SIZE = 'fontSize';

export function renderFontSizeLeaf({ children, leaf }) {

    if (leaf[MARK_FONT_SIZE]) {
        const styles = {
            fontSize: leaf[MARK_FONT_SIZE],
        };
        return (
            <span style={styles}>
                {children}
            </span>
        );
    }

    return children
};

export const FontSizePlugin = () => ({
  renderLeaf: renderFontSizeLeaf,
});
